import { InjectionToken } from '@angular/core';

export const COGNITO_CONFIGURATION = new InjectionToken<CognitoConfiguration>('reflaunt-auth.cognito-configuration');

export class CognitoConfiguration {
  userPoolId: string;
  userPoolWebClientId: string;
  domainPrefix: string;
  region: string;
  loginRedirect: string;
  logoutRedirect: string;
  resetPasswordRedirect?: string;
}
